export abstract class BaseUser {

  

}
